module.exports = __webpack_public_path__ + "img/invitation_code_icon_selected.11ff98c3.svg";